const esNodoSuelto = (el) => {
  if (!el || el.id === 'root') return false
  return el.classList.contains('modal-backdrop') || (el.classList.contains('modal') && !el.closest('#root'))
}

export const limpiarUiTrasHotReload = () => {
  if (typeof document === 'undefined') return

  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')

  document.querySelectorAll('.modal-backdrop').forEach((node) => node.remove())

  Array.from(document.body.children).forEach((el) => {
    if (esNodoSuelto(el)) el.remove()
  })

  ;['webpack-dev-server-client-overlay', 'webpack-dev-server-client-overlay-div'].forEach((id) => {
    const overlay = document.getElementById(id)
    if (overlay) overlay.remove()
  })

  document.querySelectorAll('iframe[id*="webpack-dev-server"]').forEach((node) => node.remove())
}

if (typeof module !== 'undefined' && module.hot) {
  module.hot.addStatusHandler((status) => {
    if (status === 'idle' || status === 'apply') {
      window.requestAnimationFrame(limpiarUiTrasHotReload)
      window.setTimeout(limpiarUiTrasHotReload, 50)
    }
  })
}

if (typeof window !== 'undefined') {
  window.addEventListener('load', limpiarUiTrasHotReload)
}
